import script from "./word.vue?vue&type=script&setup=true&lang=js"
export * from "./word.vue?vue&type=script&setup=true&lang=js"

import "./word.vue?vue&type=style&index=0&id=50c68f89&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50c68f89"]])

export default __exports__